var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.024,
    height: 25.084,
    viewBox: "0 0 13.024 25.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_893",
    "data-name": "Trac\\xE9 893",
    d: "M16.744.181v3.98H14.378a2.215,2.215,0,0,0-1.749.543,2.5,2.5,0,0,0-.452,1.628V9.18h4.417l-.588,4.462H12.177V25.084H7.564V13.642H3.72V9.18H7.564V5.894A5.831,5.831,0,0,1,9.132,1.545,5.69,5.69,0,0,1,13.307,0,24.938,24.938,0,0,1,16.744.181Z",
    transform: "translate(-3.72 -0.001)",
    fill: "#0ef5ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2b328f94a2e1a1e0d635fbf09a88dddb.svg";
export { ForwardRef as ReactComponent };